import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { useAccessToken } from '@/services/auth';
import {
  onFarmImplantFreezingLookupOptions,
  type OnFarmImplantLookupOption,
} from '@/services/on-farm-implant';

export type FreezingFieldOption = { value: string; label: string };

export type FreezingFieldOptions = {
  techOptions: FreezingFieldOption[];
  freezeMethodOptions: FreezingFieldOption[];
  storageLocationOptions: FreezingFieldOption[];
  defaultFreezeMethodId: string | null;
};

const toOptions = (options: OnFarmImplantLookupOption[] | undefined) =>
  (options ?? []).map((option) => ({ value: option.id, label: option.name }));

export const useFreezingFieldOptions = (
  sessionId: string | null,
): FreezingFieldOptions => {
  const token = useAccessToken();
  const { data } = useQuery({
    ...onFarmImplantFreezingLookupOptions(token, sessionId ?? ''),
    enabled: !!token && !!sessionId,
  });

  return useMemo(
    () => ({
      techOptions: toOptions(data?.techs),
      freezeMethodOptions: toOptions(data?.freezeMethods),
      storageLocationOptions: toOptions(data?.storageLocations),
      defaultFreezeMethodId: data?.defaultFreezeMethodId ?? null,
    }),
    [data],
  );
};
